import {useSearchParams} from "react-router-dom";
import {useSetting} from "contexts/setting";
import {releasesSetsForProduct} from "data/products/index";

/**
 * Resolves the active set for the releases offering.
 * Priority: URL param > scene data > default.
 * Returns undefined for a selection that has no sets.
 *
 * Sets belong to the releases channel. A product whose home is that channel
 * keeps them in every channel that lists it (`dataChannel`, see
 * src/data/offering.ts), so JetBrains Air shows the same Set dropdown when a
 * user reaches it through Social.
 *
 * The result is always a set the current product offers. Not every product
 * carries every set (JetBrains Air has no splash screen and no wallpapers),
 * and a `?set=` the product does not offer would otherwise render an empty
 * template list next to a Set dropdown showing a different value.
 */
export function useCurrentSet() {
  const [searchParams] = useSearchParams();
  const {dataChannel, product, sceneSet} = useSetting();

  if (dataChannel !== "releases") return undefined;

  const offered = releasesSetsForProduct(product?.value);
  const requested = searchParams.get("set") || sceneSet || "";
  if (offered.some((set) => set.value === requested)) return requested;
  return offered[0].value;
}
